module.exports = __webpack_public_path__ + "img/swiper_02.42babb92.jpg";